import axios from 'axios';
import config from 'api/urls-config.json';

export const getTrialResults = params => {
    return axios.get(`${config.API + config.pages.trail_results}`, { params });
};

export const getTrialResultsDetail = params => {
    const { slug, language, country } = params;

    return axios.get(`${config.API + config.pages.trail_results_slug + slug}`, {
        params: {
            language,
            country,
        },
    });
};
